module.exports = __webpack_public_path__ + "static/img/img-about-15.110ecba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-15.png
// module id = I7Q/
// module chunks = 0